<template>
  <div class="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
    <div class="max-w-7xl mx-auto space-y-6">
      <!-- Cabeçalho com título e botões de ação -->
      <div class="flex justify-between items-center mb-6">
        <div>
          <h2 class="text-2xl font-semibold text-gray-700 dark:text-gray-200">{{ companyInfo.name }}</h2>
          <p class="text-sm text-gray-500 dark:text-gray-400">Painel de Números</p>
        </div>
        
        <div class="flex space-x-2">
          <!-- <button class="px-4 py-2 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700">
            <span class="flex items-center">
              <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
              Filtros Avançados
            </span>
          </button> -->
          
          <!-- <button class="px-4 py-2 bg-blue-600 rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-700">
            <span class="flex items-center">
              <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Exportar
            </span>
          </button> -->
        </div>
      </div>
      
      <!-- Filtros -->
      <Card>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Period Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              <span class="mr-2">📅</span>
              Período
            </label>
            <select 
              v-model="selectedFilter"
              @change="handleFilterChange($event.target.value)"
              class="block w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200"
            >
              <option
                v-for="(filter, key) in filters"
                :key="key"
                :value="key"
              >
                {{ filter.label }}
              </option>
            </select>
          </div>

          <!-- Branch Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              <span class="mr-2">🏢</span>
              Unidades
            </label>
            <select
              v-model="selectedBranch"
              @change="handleBranchChange"
              class="block w-full p-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200"
            >
              <option value="all">Todas</option>
              <option :value="0">{{ mainBranchName }}</option>
              <option
                v-for="branch in branches"
                :key="branch.id"
                :value="branch.id"
              >
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>
      </Card>
      
      <!-- Substituir este trecho no DashboardCompanyPage.vue -->

      <!-- Substituir este trecho no DashboardCompanyPage.vue -->

      <!-- Stats Cards Agrupados em uma única linha -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <MultiStatsCard
          title="Resumo de Métricas"
          stat1Title="Total de Acessos"
          :stat1Value="clicksData?.total_clicks || 0"
          stat1Subtitle="No período selecionado"
          stat1Color="blue"
          
          stat2Title="Total de Avaliações"
          :stat2Value="clicksData?.total_reviews || 0"
          stat2Subtitle="No período selecionado"
          stat2Color="purple"
          
          stat3Title="NPS Score"
          :stat3Value="clicksData?.nps_average || 0"
          :stat3Subtitle="getNpsCategory(clicksData?.nps_average)"
          :stat3TextColor="getNpsTextColor(clicksData?.nps_average)"
          :stat3SubtitleColor="getNpsTextColor(clicksData?.nps_average)"
          :stat3Color="getNpsColor(clicksData?.nps_average)"
          @clickStat3="openNPSDialog"
        >
          <template #stat3TitleIcon>
            <span 
              class="inline-flex items-center justify-center ml-1 w-4 h-4 text-xs rounded-full bg-blue-100 text-blue-600 dark:bg-blue-800 dark:text-blue-300 cursor-help"
              title="Clique para saber mais sobre o NPS Score"
            >i</span>
          </template>
        </MultiStatsCard>
        
        <MultiStatsCard
          title="Distribuição NPS"
          stat1Title="Promotores"
          :stat1Value="`${npsData?.promoters || 0} (${calculatePercentage('promoters')}%)`"
          stat1Subtitle="Notas 9-10"
          stat1Color="green"
          stat1TextColor="text-green-600 dark:text-green-400"
          
          stat2Title="Neutros"
          :stat2Value="`${npsData?.neutrals || 0} (${calculatePercentage('neutrals')}%)`"
          stat2Subtitle="Notas 7-8"
          stat2Color="yellow"
          stat2TextColor="text-yellow-600 dark:text-yellow-400"
          
          stat3Title="Detratores"
          :stat3Value="`${npsData?.detractors || 0} (${calculatePercentage('detractors')}%)`"
          stat3Subtitle="Notas 0-6"
          stat3Color="red"
          stat3TextColor="text-red-600 dark:text-red-400"
        />
      </div>
      
      <!-- Charts row -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Distribuição NPS">
          <div class="h-64">
            <PieChart
              v-if="pieChartData && pieChartData.datasets"
              :data="pieChartData"
              :options="pieChartOptions"
            />
          </div>
        </Card>
        
        <Card title="Acessos ao Longo do Tempo">
          <div class="h-64">
            <LineChart
              v-if="lineChartData && lineChartData.datasets"
              :data="lineChartData"
              :options="lineChartOptions"
            />
          </div>
        </Card>
      </div>
      
      <!-- Reviews Table -->
      <Card title="Avaliações do Período">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead class="bg-gray-50 dark:bg-gray-900">
              <tr>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Data
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Unidade
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Nota
                </th>                
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Nome
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Telefone
                </th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Avaliação
                </th>
                <!-- <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Ações
                </th> -->
              </tr>
            </thead>
            <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
              <tr v-if="loading || paginatedReviews.length === 0" class="animate-pulse">
                <td colspan="7" class="px-6 py-8 text-center">
                  <div v-if="loading" class="flex justify-center">
                    <svg class="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </div>
                  <p v-else class="text-gray-500 dark:text-gray-400">Nenhuma avaliação encontrada para o período selecionado.</p>
                </td>
              </tr>
              
              <tr v-for="review in paginatedReviews" :key="review.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                  {{ formatReviewDate(review.created_at) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                  {{ review.branch_name }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span 
                    :class="[
                      'px-2 py-1 text-xs rounded-full font-medium',
                      review.nps >= 9 ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' :
                      review.nps >= 7 ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200' :
                      'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                    ]"
                  >
                    {{ review.nps }}
                  </span>
                </td>

                <td class="px-6 py-4 text-sm text-gray-500 dark:text-gray-400">
                  {{ review.contactname || '-' }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 dark:text-gray-400">
                  <a 
                    v-if="review.contactphone && review.contactphone !== '-'"
                    :href="formatWhatsAppLink(review.contactphone)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-blue-600 hover:text-blue-800 dark:hover:text-blue-400 hover:underline flex items-center"
                  >
                    {{ review.contactphone }}
                    <svg class="w-4 h-4 ml-1 text-green-600" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.36-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                    </svg>
                  </a>
                  <span v-else class="text-gray-400 dark:text-gray-500">-</span>
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 dark:text-gray-400 max-w-xs whitespace-normal break-words">
                {{ review.review || '-' }}
              </td>
                <!-- <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button class="text-blue-600 hover:text-blue-800 dark:hover:text-blue-400 mr-3">
                    Ver
                  </button>
                  <button class="text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200">
                    Responder
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- Pagination -->
        <template #footer>
          <div class="flex items-center justify-between">
            <div class="text-sm text-gray-600 dark:text-gray-400">
              Mostrando <span class="font-medium">{{ paginationStart + 1 }}</span> a <span class="font-medium">{{ paginationEnd }}</span> de <span class="font-medium">{{ reviews.length }}</span> resultados
            </div>
            
            <div class="flex space-x-2">
              <button
                @click="currentPage--"
                :disabled="currentPage === 1"
                :class="currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''"
                class="px-3 py-1 bg-white dark:bg-gray-700 border dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                Anterior
              </button>
              <button
                @click="currentPage++"
                :disabled="currentPage >= totalPages"
                :class="currentPage >= totalPages ? 'opacity-50 cursor-not-allowed' : ''"
                class="px-3 py-1 bg-white dark:bg-gray-700 border dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                Próximo
              </button>
            </div>
          </div>
        </template>
      </Card>
    </div>
    
    <!-- Modal do NPS -->
    <Teleport to="body">
      <div v-if="isNPSDialogOpen" 
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click="closeNPSDialog">
        <div class="bg-white dark:bg-gray-800 rounded-lg w-full max-w-2xl max-h-[90vh] flex flex-col shadow-xl" 
            @click.stop>
          <!-- Cabeçalho fixo -->
          <div class="p-6 border-b dark:border-gray-700">
            <div class="flex justify-between items-start">
              <h2 class="text-xl font-bold text-gray-900 dark:text-gray-100">Entenda o NPS</h2>
              <button @click="closeNPSDialog" 
                      class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                <span class="text-2xl">&times;</span>
              </button>
            </div>
          </div>
          
          <!-- Conteúdo com rolagem -->
          <div class="p-6 overflow-y-auto">
            <div class="space-y-4">
              <p class="text-gray-700 dark:text-gray-300">
                O NPS (Net Promoter Score) é uma forma simples de medir a satisfação dos seus clientes através de uma única pergunta: "Em uma escala de 0 a 10, qual a probabilidade de você recomendar nossa empresa para um amigo?"
              </p>

              <div>
                <h3 class="font-semibold mb-2 text-gray-900 dark:text-gray-100">Com base nas respostas, seus clientes são classificados em:</h3>
                <ul class="space-y-2">
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-green-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Promotores (notas 9-10):</strong> São clientes muito satisfeitos que falam bem da sua empresa</span>
                  </li>
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-yellow-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Neutros (notas 7-8):</strong> São clientes satisfeitos, mas não entusiasmados</span>
                  </li>
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-red-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Detratores (notas 0-6):</strong> São clientes insatisfeitos que podem prejudicar sua marca</span>
                  </li>
                </ul>
              </div>

              <div>
                <h3 class="font-semibold mb-2 text-gray-900 dark:text-gray-100">Como é calculado:</h3>
                <p class="text-gray-700 dark:text-gray-300">
                  Sua nota NPS é calculada subtraindo a porcentagem de detratores da porcentagem de promotores. Por exemplo: se você tem 70% de promotores e 10% de detratores, seu NPS é 60.
                </p>
              </div>

              <!-- Nova seção com as classificações -->
              <div>
                <h3 class="font-semibold mb-2 text-gray-900 dark:text-gray-100">Classificação da nota NPS baseada em benchmarks comuns do mercado:</h3>
                <ul class="space-y-2">
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-green-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Acima de 70:</strong> Excelente</span>
                  </li>
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-blue-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Entre 50 e 70:</strong> Bom</span>
                  </li>
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-yellow-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Entre 30 e 50:</strong> Adequado</span>
                  </li>
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-orange-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Entre 0 e 30:</strong> Baixo</span>
                  </li>
                  <li class="flex items-center">
                    <span class="w-3 h-3 rounded-full bg-red-500 mr-2"></span>
                    <span class="text-gray-700 dark:text-gray-300"><strong>Abaixo de 0:</strong> Crítico</span>
                  </li>
                </ul>
              </div>

              <div>
                <h3 class="font-semibold mb-2 text-gray-900 dark:text-gray-100">Como usar esta informação:</h3>
                <ul class="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                  <li>Acompanhe sua nota NPS mensalmente para identificar se suas melhorias estão tendo efeito</li>
                  <li>Entre em contato com detratores para entender os problemas e corrigi-los</li>
                  <li>Peça feedback detalhado dos promotores para saber o que está fazendo de melhor</li>
                  <li>Use os comentários dos clientes para guiar mudanças no seu negócio</li>
                </ul>
              </div>

              <p class="text-gray-700 dark:text-gray-300 font-medium">
                Quanto maior sua nota NPS, maior a chance de seu negócio crescer através de recomendações positivas dos clientes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>



<script>
import { useAuthStore } from '@/stores/auth'; // Ajuste o caminho conforme sua estrutura
import CompanyService from '@/services/company.service';
import AuthService from '@/services/auth.service';
import { defineComponent } from 'vue';
import { Line as LineChart, Pie as PieChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import Card from '../../shared/components/ui/Card.vue';
import StatsCard from '../../shared/components/ui/StatsCard.vue';
import MultiStatsCard from '../../shared/components/ui/MultiStatsCard.vue';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

export default defineComponent({
  name: 'DashboardCompanyPage',
  components: {
    LineChart,
    PieChart,
    Card,
    StatsCard,
    MultiStatsCard
  },
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_API_URL, // Define a URL base como parte do estado
      companyInfo: {
        name: ''
      },
      loading: true,
      npsData: null,
      isNPSDialogOpen: false,
      clicksData: null,
      totalClicks: null,
      totalReviews: null,
      selectedFilter: 'all',
      selectedBranch: 'all', // Default to 'all' branches
      branches: [], // Will store the list of branches
      mainBranchName: 'Principal', // Default name for main branch
      dateRange: { start: null, end: null },
      reviews: [],
      currentPage: 1,
      itemsPerPage: 10,
      userName: '', // Nova propriedade para armazenar o nome do usuário
      filters: {
        all: { 
          label: 'Mostrar Tudo', 
          getDates: () => ({ start: null, end: null }) 
        },
        today: {
          label: 'Hoje',
          getDates: () => {
            const today = new Date();
            // Configura para início do dia
            today.setHours(0, 0, 0, 0);
            return { start: today, end: today };
          }
        },
        yesterday: {
          label: 'Ontem',
          getDates: () => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            yesterday.setHours(0, 0, 0, 0);
            return { start: yesterday, end: yesterday };
          }
        },
        thisWeek: {
          label: 'Esta Semana',
          getDates: () => {
            const today = new Date();
            const start = new Date(today);
            start.setDate(today.getDate() - today.getDay());
            start.setHours(0, 0, 0, 0);
            return { start, end: today };
          }
        },
        thisMonth: {
          label: 'Mês Atual',
          getDates: () => {
            const today = new Date();
            const start = new Date(today.getFullYear(), today.getMonth(), 1);
            start.setHours(0, 0, 0, 0);
            return { start, end: today };
          }
        },
        last30: {
          label: 'Últimos 30 dias',
          getDates: () => {
            const today = new Date();
            const start = new Date();
            start.setDate(today.getDate() - 30);
            start.setHours(0, 0, 0, 0);
            return { start, end: today };
          }
        },
        last90: {
          label: 'Últimos 90 dias',
          getDates: () => {
            const today = new Date();
            const start = new Date();
            start.setDate(today.getDate() - 90);
            start.setHours(0, 0, 0, 0);
            return { start, end: today };
          }
        }
      }
    };
  },
  methods: {
    // Método para obter o texto da categoria do NPS
    getNpsCategory(score) {
      if (score === null || score === undefined) return '';
      if (score >= 70) return 'Excelente';
      if (score >= 50) return 'Bom';
      if (score >= 30) return 'Adequado';
      if (score >= 0) return 'Baixo';
      return 'Crítico';
    },


    // Método para obter a cor do texto baseada no score NPS
    getNpsTextColor(score) {
      if (score === null || score === undefined) return '';
      if (score >= 70) return 'text-green-600 dark:text-green-400';
      if (score >= 50) return 'text-blue-600 dark:text-blue-400';
      if (score >= 30) return 'text-yellow-600 dark:text-yellow-400';
      if (score >= 0) return 'text-orange-500 dark:text-orange-400';
      return 'text-red-600 dark:text-red-400';
    },
    
    // Método para obter a cor baseada no score NPS
    getNpsColor(score) {
      if (score === null || score === undefined) return 'blue';
      if (score >= 70) return 'green';
      if (score >= 50) return 'blue';
      if (score >= 30) return 'yellow';
      if (score >= 0) return 'orange';
      return 'red';
    },
    
    // Calcular percentual de satisfação geral (simplificação para UI)
    calculateSatisfactionPercentage() {
      if (!this.npsData) return 0;
      const total = this.npsData.promoters + this.npsData.neutrals + this.npsData.detractors;
      if (total === 0) return 0;
      // Considerando satisfeitos como promotores + parte dos neutros (75%)
      const satisfied = this.npsData.promoters + (this.npsData.neutrals * 0.75);
      return Math.round((satisfied / total) * 100);
    },
    
    // Método para lidar com o logout
    logout() {
      const authStore = useAuthStore();
      authStore.logout();
      this.$router.push({ name: 'login' });
    },
    
    // Método para obter os dados do usuário logado
    async fetchUserData() {
      const authStore = useAuthStore();
      if (authStore.user) {
        this.userName = authStore.user.username || authStore.user.email || 'Usuário';
      }
    },
    
    // Métodos para controlar o modal NPS
    openNPSDialog() {
      this.isNPSDialogOpen = true;
    },
    
    closeNPSDialog() {
      this.isNPSDialogOpen = false;
    },
    
    // Buscar as unidades/filiais
    async fetchBranches() {
      try {
        // Buscar unidades da API usando CompanyService.getBranches
        const response = await CompanyService.getBranches(this.companyId);
        this.branches = response.data;

        // Buscar nome da unidade principal das preferências
        const prefsResponse = await CompanyService.getCompanyPrefs(this.companyId);
        if (prefsResponse.data && prefsResponse.data.name) {
          this.mainBranchName = prefsResponse.data.name;
        }
      } catch (error) {
        console.error('Erro ao buscar unidades:', error);
      }
    },
    
    // Buscar todos os dados do dashboard
    async fetchData() {
      this.loading = true;
      try {
        const { start, end } = this.dateRange;
        const params = new URLSearchParams();
        if (start) params.append('start_date', this.formatDate(start));
        if (end) params.append('end_date', this.formatDate(end));
        if (this.selectedBranch !== 'all') {
          params.append('branch_id', this.selectedBranch);
        }

        const queryParams = params.toString() ? `?${params.toString()}` : '';

        // Buscar dados da empresa
        const companyResponse = await CompanyService.getCompany(this.companyId);
        this.companyInfo.name = companyResponse.data.name;
        
        // Usar AuthService.makeRequest em vez de axios.get diretamente
        // para garantir que o token de autenticação seja incluído nas requisições
        const [dashboardResponse, reviewsResponse] = await Promise.all([
          await AuthService.makeRequest({
            url: `/companies/${this.companyId}/dashboard${queryParams}`,
            method: 'GET'
          }),
          await AuthService.makeRequest({
            url: `/companies/${this.companyId}/reviews${queryParams}`,
            method: 'GET'
          })
        ]);
  
        if (dashboardResponse.data) {
          this.npsData = dashboardResponse.data.nps_data;
          this.clicksData = dashboardResponse.data;
        }
  
        if (reviewsResponse.data) {
          this.reviews = reviewsResponse.data;
          this.currentPage = 1;
        }
  
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // Formatar link para WhatsApp
    formatWhatsAppLink(phone) {
      // Remove caracteres não numéricos
      const cleanPhone = phone.replace(/\D/g, '');
      
      // Se o número não começar com '+' ou '55', adiciona o código do Brasil
      const formattedPhone = cleanPhone.startsWith('55') ? cleanPhone : `55${cleanPhone}`;
      
      // Retorna o link do WhatsApp
      return `https://wa.me/${formattedPhone}`;
    },
    
    // Atualizar dados quando a unidade mudar
    handleBranchChange() {
      this.fetchData();
    },

    // Formatar data para a API (yyyy-mm-dd)
    formatDate(date) {
      if (!date) return null;
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    
    // Formatar data para exibição na tabela
    formatReviewDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    },
    
    // Atualizar dados quando o filtro de período mudar
    handleFilterChange(filterKey) {
      this.selectedFilter = filterKey;
      this.dateRange = this.filters[filterKey].getDates();
      this.fetchData();
    },
    
    // Calcular percentual para cada tipo NPS
    calculatePercentage(type) {
      if (!this.npsData) return '0.0';
      const total = this.npsData.promoters + this.npsData.neutrals + this.npsData.detractors;
      if (total === 0) return '0.0';
      return ((this.npsData[type] / total) * 100).toFixed(1);
    }
  },
  computed: {
    pieChartData() {
      if (!this.npsData) return null;
      
      return {
        labels: ['Promotores', 'Neutros', 'Detratores'],
        datasets: [{
          data: [
            this.npsData.promoters || 0,
            this.npsData.neutrals || 0,
            this.npsData.detractors || 0
          ],
          backgroundColor: [
            '#10B981',  // Verde para promotores
            '#FBBF24',  // Amarelo para neutros
            '#EF4444'   // Vermelho para detratores
          ]
        }]
      };
    },
    lineChartData() {
      if (!this.clicksData?.clicks_by_date) return null;
      
      const labels = Object.keys(this.clicksData.clicks_by_date).sort();
      const data = labels.map(date => this.clicksData.clicks_by_date[date]);
      
      return {
        labels,
        datasets: [{
          label: 'Acessos',
          data: data,
          borderColor: '#3B82F6',
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          tension: 0.3,
          fill: true
        }]
      };
    },
    pieChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 15,
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || '';
                const value = context.formattedValue;
                const dataset = context.dataset;
                const total = dataset.data.reduce((acc, data) => acc + data, 0);
                const percentage = Math.round((context.raw / total) * 100);
                return `${label}: ${value} (${percentage}%)`;
              }
            }
          }
        },
        cutout: '65%'
      };
    },
    lineChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
              precision: 0
            },
            grid: {
              drawBorder: false
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        },
        elements: {
          point: {
            radius: 3,
            hoverRadius: 5
          }
        }
      };
    },
    paginatedReviews() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.reviews.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.reviews.length / this.itemsPerPage);
    },
    paginationStart() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    paginationEnd() {
      const end = this.currentPage * this.itemsPerPage;
      return end > this.reviews.length ? this.reviews.length : end;
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchBranches(),
        this.fetchUserData()
      ]);
      await this.fetchData();
    } catch (error) {
      console.error('Erro na inicialização do dashboard:', error);
    }
  },
  watch: {
    // Observar mudanças no companyId para recarregar dados
    companyId: {
      immediate: false,
      handler() {
        this.fetchBranches();
        this.fetchData();
      }
    }
  }
});
</script>

